import {Concept} from 'types';
import type {ModifiableSchemaReference} from 'schemas/types';
import {getManifestationBasedModifier} from 'schemas/schemas';
import type {GetDataBasedModifier} from 'services/metadata/types';

export const getGetDataBasedSchemaModifiers = (
  schemaRef: ModifiableSchemaReference,
): GetDataBasedModifier | undefined => {
  switch (schemaRef) {
    case Concept.work:
    case Concept.expression: {
      return undefined;
    }
    case Concept.manifestation: {
      return getManifestationBasedModifier;
    }
  }
};
